<mat-card class="em-form form-dialogo">
  <app-card-header
    [title]="title"
    [subtitle]="subtitle"
    icono="emergency"
    [draggable]="true"
    [botonCerrar]="true"
    (cerrar)="cancelar()"
  ></app-card-header>

  <mat-divider></mat-divider>

  @if (form && formUbicacion && !loading) {
    <form
      id="form"
      [formGroup]="form"
      autocomplete="off"
      (ngSubmit)="onSubmit()"
    >
      <mat-card-content class="card-content-crear">
        <!-- Situación -->
        <app-content-card title="Situación" icon="alt_route" color="red">
          @if (!esEdicion) {
            <div
              class="em-situaciones"
              role="radiogroup"
              aria-label="Situación de la emergencia"
            >
              @for (op of opcionesSituacion; track op.valor) {
                <button
                  type="button"
                  role="radio"
                  class="em-situacion irx-opcion"
                  [class.irx-opcion--activa]="situacion === op.valor"
                  [attr.aria-checked]="situacion === op.valor"
                  [style.--tono]="op.presentacion.color"
                  (click)="elegirSituacion(op.valor)"
                >
                  <span class="em-situacion__icono">
                    <mat-icon>{{ op.presentacion.icono }}</mat-icon>
                  </span>
                  <span class="em-situacion__texto">
                    <strong>{{ op.presentacion.label }}</strong>
                    <small>{{ op.descripcion }}</small>
                  </span>
                  <mat-icon class="em-situacion__check">
                    {{
                      situacion === op.valor
                        ? 'radio_button_checked'
                        : 'radio_button_unchecked'
                    }}
                  </mat-icon>
                </button>
              }
            </div>
          } @else {
            <div class="em-situaciones">
              <div
                class="em-situacion em-situacion--activa em-situacion--fija"
                [style.--tono]="situacionActual.color"
              >
                <span class="em-situacion__icono">
                  <mat-icon>{{ situacionActual.icono }}</mat-icon>
                </span>
                <span class="em-situacion__texto">
                  <strong>{{ situacionActual.label }}</strong>
                  <small>
                    La situación no se puede cambiar después de crear la
                    emergencia. El estado se cambia desde las acciones del
                    detalle o del listado.
                  </small>
                </span>
              </div>
            </div>
          }
        </app-content-card>

        <!-- Código y solicitud -->
        <app-content-card
          title="Código y solicitud"
          icon="support_agent"
          color="blue"
        >
          <section class="inputs-group">
            <ng-select
              class="custom-ng-select em-campo"
              [items]="prioridades"
              bindValue="valor"
              bindLabel="valor"
              formControlName="prioridadApertura"
              placeholder="Código de apertura"
              [clearable]="false"
              [searchable]="false"
              appendTo="body"
            >
              <ng-template ng-option-tmp let-item="item">
                <span class="em-prioridad">
                  <span
                    class="em-prioridad__punto"
                    [style.background]="item.presentacion.color"
                  ></span>
                  {{ item.presentacion.label }}
                </span>
              </ng-template>
              <ng-template ng-label-tmp let-item="item">
                <span class="em-prioridad">
                  <span
                    class="em-prioridad__punto"
                    [style.background]="item.presentacion.color"
                  ></span>
                  {{ item.presentacion.label }}
                </span>
              </ng-template>
            </ng-select>

            <ng-select
              class="custom-ng-select em-campo"
              [items]="solicitantes"
              formControlName="solicitante"
              placeholder="Solicitante"
              notFoundText="Sin solicitantes cargados para el cliente"
              [searchable]="true"
              appendTo="body"
            ></ng-select>

            <mat-form-field class="em-campo">
              <mat-icon matPrefix>phone</mat-icon>
              <mat-label>Teléfono</mat-label>
              <input matInput formControlName="telefono" />
              <mat-hint>Se completa con el del paciente</mat-hint>
            </mat-form-field>
          </section>
        </app-content-card>

        <!-- Paciente -->
        <app-content-card title="Paciente" icon="personal_injury" color="green">
          <section class="inputs-group">
            <div class="em-fila-boton">
              <ng-select
                class="custom-ng-select"
                [items]="pacientes"
                bindValue="_id"
                formControlName="idDestinatarioAsistencia"
                placeholder="Paciente"
                notFoundText="Sin pacientes que coincidan"
                [searchable]="true"
                [searchFn]="buscarPaciente"
                appendTo="body"
              >
                <ng-template ng-option-tmp let-item="item">
                  <div class="em-paciente">
                    <strong>{{ item?.nombre }} {{ item?.apellido }}</strong>
                    <small>
                      @if (item?.dni) {
                        DNI {{ item.dni }}
                      } @else {
                        <span class="no-info">Sin DNI</span>
                      }
                      @if (item?.edad != null) {
                        · {{ item.edad }} años
                      }
                      @if (item?.obraSocial) {
                        · {{ item.obraSocial }}
                      }
                    </small>
                  </div>
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                  {{ item?.nombre }} {{ item?.apellido }}
                  @if (item?.dni) {
                    <small>(DNI {{ item.dni }})</small>
                  }
                </ng-template>
              </ng-select>
              @if (
                helper.tienePermiso('Emergencias Médicas - Crear pacientes')
              ) {
                <button
                  irxBotonIcono="borde"
                  tamano="campo"
                  tooltip="Crear paciente"
                  (click)="crearPaciente()"
                >
                  <mat-icon>add</mat-icon>
                </button>
              }
            </div>
          </section>
        </app-content-card>

        <!-- Datos médicos -->
        <app-content-card
          title="Datos médicos"
          icon="medical_information"
          color="purple"
        >
          <section class="inputs-group em-columna">
            <app-listado-categoria-selector
              [idCliente]="clienteId ?? null"
              categoria="Sintomas"
              [categorias]="['Sintomas']"
              placeholder="Síntomas"
              notFoundText="Sin síntomas que coincidan"
              [multiple]="true"
              [allowCreate]="true"
              [showCrearBtn]="true"
              [initialNames]="sintomasIniciales"
              (listadoCategoriasChange)="onSintomasChange($event)"
            ></app-listado-categoria-selector>

            @for (sintoma of sintomasConComplemento; track sintoma) {
              <mat-form-field class="em-campo">
                <mat-icon matPrefix>edit_note</mat-icon>
                <mat-label>{{ sinSuspensivos(sintoma) }}…</mat-label>
                <input
                  matInput
                  [value]="sintomasComplementos.get(sintoma) || ''"
                  (input)="setComplemento(sintoma, $any($event.target).value)"
                />
                <mat-hint>Completá el síntoma</mat-hint>
              </mat-form-field>
            }

            <app-listado-categoria-selector
              [idCliente]="clienteId ?? null"
              categoria="Diagnosticos"
              [categorias]="['Diagnosticos']"
              placeholder="Diagnóstico"
              notFoundText="Sin diagnósticos que coincidan"
              [multiple]="false"
              [allowCreate]="true"
              [showCrearBtn]="true"
              [initialNames]="diagnosticoInicial"
              (listadoCategoriaChange)="onDiagnosticoChange($event)"
            ></app-listado-categoria-selector>

            @if (requiereComplemento(diagnosticoSeleccionado)) {
              <mat-form-field class="em-campo">
                <mat-icon matPrefix>edit_note</mat-icon>
                <mat-label>
                  {{ sinSuspensivos(diagnosticoSeleccionado) }}…
                </mat-label>
                <input matInput formControlName="diagnosticoComplemento" />
                <mat-hint>Completá el diagnóstico</mat-hint>
              </mat-form-field>
            }

            <mat-form-field class="em-campo">
              <mat-icon matPrefix>notes</mat-icon>
              <mat-label>Observaciones</mat-label>
              <textarea
                matInput
                formControlName="observaciones"
                rows="3"
              ></textarea>
            </mat-form-field>
          </section>
        </app-content-card>

        <!-- Registrada finalizada: datos de la atención -->
        @if (esRegistradaFinalizada) {
          <app-content-card
            title="Atención ya realizada"
            icon="task_alt"
            color="teal"
          >
            @if (!esEdicion) {
              <section class="inputs-group">
                <ng-select
                  class="custom-ng-select em-campo"
                  [items]="medicos"
                  bindLabel="nombre"
                  bindValue="_id"
                  formControlName="idsMedicos"
                  placeholder="Médicos"
                  notFoundText="Sin médicos cargados"
                  [multiple]="true"
                  appendTo="body"
                ></ng-select>
                <ng-select
                  class="custom-ng-select em-campo"
                  [items]="enfermeros"
                  bindLabel="nombre"
                  bindValue="_id"
                  formControlName="idsEnfermeros"
                  placeholder="Enfermeros"
                  notFoundText="Sin enfermeros cargados"
                  [multiple]="true"
                  appendTo="body"
                ></ng-select>
                <ng-select
                  class="custom-ng-select em-campo"
                  [items]="hospitales"
                  bindLabel="identificacion"
                  bindValue="_id"
                  formControlName="idHospital"
                  placeholder="Hospital"
                  notFoundText="Sin hospitales cargados"
                  appendTo="body"
                >
                  <ng-template ng-option-tmp let-item="item">
                    {{ item?.identificacion }}
                    @if (item?.valores?.gestion) {
                      <small class="em-tenue">
                        ({{ item.valores.gestion }})
                      </small>
                    }
                  </ng-template>
                </ng-select>
              </section>
            }

            <section class="inputs-group">
              <mat-form-field class="em-campo">
                <mat-icon matPrefix>medical_services</mat-icon>
                <mat-label>Tratamiento</mat-label>
                <textarea
                  matInput
                  formControlName="tratamiento"
                  rows="2"
                ></textarea>
              </mat-form-field>
              <mat-form-field class="em-campo">
                <mat-icon matPrefix>medication</mat-icon>
                <mat-label>Medicación</mat-label>
                <textarea
                  matInput
                  formControlName="medicacion"
                  rows="2"
                ></textarea>
              </mat-form-field>
            </section>

            <p class="em-subtitulo">Signos vitales</p>
            <section class="inputs-group em-signos">
              <mat-form-field>
                <mat-label>Tensión arterial</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="tensionArterial"
                />
                <span matTextSuffix>mmHg</span>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Frec. respiratoria</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="frecuenciaRespiratoria"
                />
                <span matTextSuffix>irpm</span>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Frec. cardíaca</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="frecuenciaCardiaca"
                />
                <span matTextSuffix>lpm</span>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Saturación O₂</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="saturacionOxigeno"
                />
                <span matTextSuffix>%</span>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Temperatura</mat-label>
                <input matInput type="number" formControlName="temperatura" />
                <span matTextSuffix>°C</span>
              </mat-form-field>
            </section>

            <p class="em-subtitulo">Traslado</p>
            <section class="inputs-group">
              <app-checkbox
                title="Requiere traslado"
                formControlName="traslado"
                margin="0"
              ></app-checkbox>
              @if (form.get('traslado')?.value) {
                <mat-form-field class="em-campo">
                  <mat-icon matPrefix>place</mat-icon>
                  <mat-label>Destino del traslado</mat-label>
                  <input matInput formControlName="trasladoDireccion" />
                </mat-form-field>
                <app-checkbox
                  title="El paciente acepta el traslado"
                  formControlName="aceptaTraslado"
                  margin="0"
                ></app-checkbox>
              }
            </section>
          </app-content-card>
        }

        <!-- Ubicación -->
        @if (llevaUbicacion) {
          <app-content-card
            title="Ubicación"
            [subtitle]="
              esAuxilio
                ? 'Obligatoria: es adonde va el móvil'
                : 'Opcional en un seguimiento'
            "
            icon="location_on"
            color="orange"
          >
            <div class="mapa-embebido-wrapper">
              <app-mapa-ubicar
                [raster]="'google'"
                [form]="ubicacion"
                [sinValorPorDefecto]="true"
                [centrarA]="centrarA"
                [enableAutocomplete]="true"
                [direccionElegida]="emergencia?.direccion"
                (direccion)="patchDireccion($event)"
              ></app-mapa-ubicar>
            </div>
          </app-content-card>
        }

        <!-- Adjuntos -->
        <app-content-card
          title="Archivos adjuntos"
          icon="attach_file"
          color="gray"
        >
          <app-subir-archivos
            textoBoton="Subir documentos"
            [allowMultiple]="true"
            [(archivos)]="archivosSubidos"
            (loadingFile)="subiendoArchivos = $event"
            [descripcion]="true"
          ></app-subir-archivos>
        </app-content-card>
      </mat-card-content>

      <mat-divider></mat-divider>

      <mat-card-actions class="actions-create">
        <app-button
          matType="mat-fab extended"
          color="neutral"
          (click)="cancelar()"
          text="Cancelar"
          icon="close"
        ></app-button>
        <app-button
          matType="mat-fab extended"
          [disabled]="!puedeGuardar"
          color="primary"
          text="Guardar"
          icon="save"
          type="submit"
        ></app-button>
      </mat-card-actions>
    </form>
  } @else {
    <section class="inputs-group">
      <app-loading text="Cargando formulario..." [diameter]="60"></app-loading>
    </section>
  }
</mat-card>
